import Vue from 'vue'//Vue本体の読み込み（本来、Vueはmain.jsでインポートされているが、Vue.use(Router)に必要なため再度インポート）
import Router from "vue-router"//VueRouterの読み込み（ページの切り替え機能を提供するライブラリ）
import Page_1 from "./components/Page1.vue"
import Page_2 from "./components/Page2.vue"
import Login from "./components/Login.vue"
import Store from '@/store/index.js'//状態管理用のストアをインポート（ログイン状態を管理するため）

//VueにVueRouterを使用することを宣言 →ページの切り替え機能を追加
Vue.use(Router)//VueRouterを使用することを宣言

//console.log('BASE_URL:', process.env.BASE_URL)

//export default new Router({
//ルーターインスタンスの作成 const router でインスタンス化
const router = new Router({
  mode: "history",//URLのハッシュ（#）を使用しないヒストリーモードを指定（URLがクリーンになる）
  base: process.env.BASE_URL,//ルートの定義
  
  routes: [
    //ルートアクセス時は'/iwatsuki'にリダイレクトする設定
    {
      path: '/',
      //リダイレクト設定→ルートアクセス時に'/iwatsuki'に自動的に遷移する
      redirect: '/iwatsuki'
    },

    //ルートアクセス時はLoginコンポーネントを表示する設定
    {
      path: '/iwatsuki',
      component: Login,
      name: 'login',
    },

    //'/iwatsuki/TouchLog'にアクセスしたときにPage_1コンポーネントを表示する設定
    {
      path: '/iwatsuki/TouchLog',          
      component: Page_1,       
      name: 'touchlog',           
      meta: {
        requiresAuth: true//認証が必要なページ
      }
    },
    {
      path: '/Page2',
      component: Page_2,
      name: 'page2',
      meta: {
        requiresAuth: true//認証が必要なページ
      }
    },

  ]
});

//ナビゲーションガードの設定→画面遷移の前にチェックを入れる仕組み
//引数to:遷移先のルート情報、from:遷移元のルート情報、next:遷移を許可するための関数
//アロー関数で定義
//to.matched→マッチしたルートレコードの配列
//record =>ログイン後に元のページに戻るため
//もしrequiresAuthがtrueのルートがある場合、ログイン状態をチェック
//Store.state.isLogin→Vuexストアの状態からログイン状態を取得
//もしログインしていない場合、next()関数を呼び出して、ログインページにリダイレクトする
router.beforeEach((to, from, next) => {
  //requiresAuth が true のルートが1つでもあるか？
  if (to.matched.some(record => record.meta.requiresAuth)) {
    //ログイン状態をチェック
    //ログインしていない場合、ログインページにリダイレクト
    if (!Store.state.isLogin) {
      next({
        path: '/iwatsuki',
        //リダイレクト先のURLに遷移前のURLをクエリパラメータとして付与する
        //現在は、ログイン後に遷移前のURLにリダイレクトする機能は実装されていないが、将来的に実装するための準備として、クエリパラメータを付与している
        query: {
          //to.fullPath→遷移先のURLを取得して、リダイレクト先のURLにクエリパラメータとして付与する
          redirect: to.fullPath
        }
      })
    } else {
      next();
    }
  } else {
    next();
  }
});

export default router